import styled from "@emotion/styled";
import React from "react";
import Dropzone from "react-dropzone";
import { Field, useForm } from "react-final-form";
import { OnChange } from "react-final-form-listeners";
import { Col, Row } from "reactstrap";
import ChipArray from "src/components/ChipArrayV2/ChipArray";
import TextField from "src/components/Form/TextFieldV2/TextFieldV2";
import TypeaheadField from "src/components/Form/TypeaheadFieldV2/TypeaheadFieldV2";
import Icon, { IconName } from "src/components/Icon/Icon";
import * as S from "src/constants/StringConstants";
import { EmailField, Label } from "../../../../components/Form/EmailField/EmailField";

import { MyEditor } from "./MyEditor";

export const FilesContainer = styled.label`
  display: flex;
  align-items: center;
`;

export const DropContainer = styled.label`
  padding-top: 8px;
`;

interface MemoFormProps {
  memoTypes: any;
  deliveryTypes: any;
  states: any;
  onTypeChange: (value: string) => void;
}

const MemoForm = (props: MemoFormProps) => {
  const form = useForm();

  const handleDrop = (accepted, rejected) => {
    accepted.forEach(file => {
      form.mutators.push("attachments", file);
    });
  };

  return (
    <>
      <Row>
        <Col sm="6">
          <Row>
            <Col>
              <TypeaheadField name="memoTypeID" label={S.APP_MEMO_FIELD_TYPE} options={props.memoTypes} />
              <OnChange name="memoTypeID">
                {value => {
                  props.onTypeChange(value);
                }}
              </OnChange>
            </Col>
            <Col>
              <TextField name="agentFirstName" label={S.APP_MEMO_FIELD_FIRST_NAME} />
            </Col>
            <Col>
              <TextField name="companyName" label={S.APP_MEMO_FIELD_COMPANY} />
            </Col>
          </Row>
          <Row>
            <Col>
              <TypeaheadField name="delivery" label={S.APP_MEMO_FIELD_DELIVERY} options={[]} />
            </Col>
            <Col>
              <TextField name="addressLine1" label={S.APP_MEMO_FIELD_ADDRESS} />
              <TextField name="addressLine2" label={S.APP_MEMO_FIELD_ADDRESS} bare />
            </Col>
            <Col>
              <TextField name="city" label={S.APP_MEMO_FIELD_CITY} />
            </Col>
          </Row>
          <Row>
            <Col>
              <TextField name="description" label="Description" />
            </Col>
            <Col>
              <TypeaheadField name="state" label={S.APP_MEMO_FIELD_STATE} options={props.states} />
            </Col>
            <Col>
              <TextField name="zipCode" label={S.APP_MEMO_FIELD_ZIP} />
            </Col>
          </Row>
          <hr />
          <Row>
            <Col>
              <EmailField name="toEmailAddresses" label={S.APP_MEMO_FIELD_TO} />
            </Col>
          </Row>
          <Row>
            <Col>
              <EmailField name="ccEmailAddresses" label={S.APP_MEMO_FIELD_CC} />
            </Col>
          </Row>
          <Row>
            <Col>
              <TextField name="subject" label={S.APP_MEMO_FIELD_SUBJECT} />
            </Col>
          </Row>
          <Row>
            <Col style={{ height: "380px" }}>
              <Label>{S.APP_MEMO_FIELD_BODY}</Label>
              <Field type="hidden" name="memoBody">
                {({ input: { value, ...input }, meta }) => (
                  <MyEditor
                    content={value}
                    onChange={newValue => {
                      input.onChange(newValue);
                    }}
                  />
                )}
              </Field>
            </Col>
          </Row>
          <Row>
            <Col>
              <Label>{S.APP_MEMO_FIELD_ATTACHMENTS}</Label>
            </Col>
            {/* // TODO: handle existing files */}
            <FilesContainer>
              <Dropzone onDrop={handleDrop}>
                {({ getRootProps, getInputProps, isDragActive }) => (
                  <DropContainer
                    className={`${isDragActive ? "active" : ""}`}
                    {...getRootProps()}
                    onClick={e => e.stopPropagation()}>
                    <input {...getInputProps()} />
                    <Icon name={IconName.Attachment} />
                  </DropContainer>
                )}
              </Dropzone>
              <ChipArray
                name={"attachments"}
                chipStyles={{ backgroundColor: "#eee", color: "black" }}
                itemRenderer={file => file.path}
              />
            </FilesContainer>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default MemoForm;
